import { isMac } from '@/pages/Labeling/components/ShortcutDrawer/os'
import { UserShortcut } from '@/api/LabelingNode/types'

export const COMMON_SHORTCUTS = {
  MAC: {
    COPY: 'Cmd+KeyC',
    PASTE: 'Cmd+KeyV',
    CUT: 'Cmd+KeyX',
    DELETE1: 'Delete',
    BACKSPACE_DELETE: 'Backspace',
    DELETE2: 'Escape',
    ZOOM_IN: 'Cmd+Equal',
    ZOOM_OUT: 'Cmd+Minus',
    UNDO: 'Cmd+KeyZ',
    REDO: 'Cmd+Shift+KeyZ',
    SAVE: 'Cmd+KeyS',
  },
  WIN: {
    COPY: 'Ctrl+KeyC',
    PASTE: 'Ctrl+KeyV',
    CUT: 'Ctrl+KeyX',
    DELETE1: 'Delete',
    BACKSPACE_DELETE: 'Backspace',
    DELETE2: 'Escape',
    ZOOM_IN: 'Ctrl+Equal',
    ZOOM_OUT: 'Ctrl+Minus',
    UNDO: 'Ctrl+KeyZ',
    REDO: 'Ctrl+Shift+KeyZ',
    SAVE: 'Ctrl+KeyS',
  },
} as const

export const FILE_SHORTCUTS = {
  MAC: {
    TOGGLE_IMAGE_DRAWER: '',
    PREV_IMAGE: '',
    NEXT_IMAGE: '',
    TOGGLE_TRACKING: '',
  },
  WIN: {
    TOGGLE_IMAGE_DRAWER: '',
    PREV_IMAGE: '',
    NEXT_IMAGE: '',
    TOGGLE_TRACKING: '',
  },
} as const

export const LABEL_SHORTCUTS = {
  MAC: {
    SELECT_CLASS: '',
    POINTER: 'KeyA',
    RECTANGLE: 'KeyR',
    ELLIPSE: 'KeyE',
    POLYGON: 'KeyP',
    BRUSH: 'KeyB',
    MAGIC_WAND: '',
    AUTO_PIXEL: '',
    OPACITY: '',
  },
  WIN: {
    SELECT_CLASS: '',
    POINTER: 'KeyA',
    RECTANGLE: 'KeyR',
    ELLIPSE: 'KeyE',
    POLYGON: 'KeyP',
    BRUSH: 'KeyB',
    MAGIC_WAND: '',
    AUTO_PIXEL: '',
    OPACITY: '',
  },
} as const

export const OS_TYPE = {
  MAC: 'MAC',
  WIN: 'WIN',
}

export const ACTION_TYPE = {
  COMMON: {
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
    UNDO: 'undo',
    REDO: 'redo',
    TOGGLE_IMAGE_DRAWER: 'toggleImageDrawer',
    PREV_IMAGE: 'prevImage',
    NEXT_IMAGE: 'nextImage',
    FINISH_ON: 'finishOn',
    FINISH_OFF: 'finishOff',
    DELETE_ALL_OBJECTS: 'deleteAllObjects',
  },
  LABELING: {
    SELECT_CLASS: 'selectClass',
    POINTER: 'pointer',
    RECTANGLE: 'rectangle',
    ELLIPSE: 'ellipse',
    POLYGON: 'polygon',
    BRUSH: 'brush',
    OPACITY: 'opacity',
    OCR: 'ocr',
    COMMENT: 'comment',
    // NOTE: 비디오 라벨링 단축키인 MARK_IN_OUT과 단축키를 공유합니다.
    MAGIC_WAND: 'magicWand',
    AUTO_PIXEL: 'autoPixel',
    LABEL_ASSISTANT: 'labelAssistant',
    TOGGLE_TRACKING: 'toggleStamp',
    SEMI_AUTO_LABELING: 'semiAutoLabeling',
    EXCLUSION_AREA: 'exclusionArea',
  },
} as const

// TODO: fix default keys
export const DEFAULT_SHORTCUTS: UserShortcut[] = [
  { action: ACTION_TYPE.COMMON.ZOOM_IN, shortcutKey: 'Cmd+Equal', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.ZOOM_OUT, shortcutKey: 'Cmd+Minus', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.UNDO, shortcutKey: 'Cmd+KeyZ', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.REDO, shortcutKey: 'Cmd+Shift+KeyZ', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.TOGGLE_IMAGE_DRAWER, shortcutKey: 'KeyI', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.PREV_IMAGE, shortcutKey: 'KeyQ', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.NEXT_IMAGE, shortcutKey: 'KeyW', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.FINISH_ON, shortcutKey: 'KeyD', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.FINISH_OFF, shortcutKey: 'Shift+KeyD', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.COMMON.DELETE_ALL_OBJECTS, shortcutKey: 'Shift+Backspace', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.SELECT_CLASS, shortcutKey: 'KeyC', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.POINTER, shortcutKey: 'KeyV', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.RECTANGLE, shortcutKey: 'KeyR', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.ELLIPSE, shortcutKey: 'KeyE', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.POLYGON, shortcutKey: 'KeyP', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.BRUSH, shortcutKey: 'KeyB', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.OCR, shortcutKey: 'KeyT', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.COMMENT, shortcutKey: 'Shift+KeyC', type: OS_TYPE.MAC },
  // NOTE: 비디오 라벨링 단축키인 MARK_IN_OUT과 단축키를 공유합니다.
  { action: ACTION_TYPE.LABELING.MAGIC_WAND, shortcutKey: 'KeyM', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.AUTO_PIXEL, shortcutKey: 'KeyA', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.LABEL_ASSISTANT, shortcutKey: 'Shift+KeyQ', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.SEMI_AUTO_LABELING, shortcutKey: 'Shift+KeyP', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.TOGGLE_TRACKING, shortcutKey: 'KeyS', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.OPACITY, shortcutKey: 'KeyO', type: OS_TYPE.MAC },
  { action: ACTION_TYPE.LABELING.EXCLUSION_AREA, shortcutKey: 'Shift+KeyI', type: OS_TYPE.MAC },

  // WINDOWS
  { action: ACTION_TYPE.COMMON.ZOOM_IN, shortcutKey: 'Ctrl+Equal', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.ZOOM_OUT, shortcutKey: 'Ctrl+Minus', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.UNDO, shortcutKey: 'Ctrl+KeyZ', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.REDO, shortcutKey: 'Ctrl+Shift+KeyZ', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.TOGGLE_IMAGE_DRAWER, shortcutKey: 'KeyI', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.PREV_IMAGE, shortcutKey: 'KeyQ', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.NEXT_IMAGE, shortcutKey: 'KeyW', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.FINISH_ON, shortcutKey: 'KeyD', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.FINISH_OFF, shortcutKey: 'Shift+KeyD', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.COMMON.DELETE_ALL_OBJECTS, shortcutKey: 'Shift+Backspace', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.SELECT_CLASS, shortcutKey: 'KeyC', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.POINTER, shortcutKey: 'KeyV', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.RECTANGLE, shortcutKey: 'KeyR', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.ELLIPSE, shortcutKey: 'KeyE', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.POLYGON, shortcutKey: 'KeyP', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.BRUSH, shortcutKey: 'KeyB', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.OCR, shortcutKey: 'KeyT', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.COMMENT, shortcutKey: 'Shift+KeyC', type: OS_TYPE.WIN },
  // NOTE: 비디오 라벨링 단축키인 MARK_IN_OUT과 단축키를 공유합니다.
  { action: ACTION_TYPE.LABELING.MAGIC_WAND, shortcutKey: 'KeyM', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.AUTO_PIXEL, shortcutKey: 'KeyA', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.LABEL_ASSISTANT, shortcutKey: 'Shift+KeyQ', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.SEMI_AUTO_LABELING, shortcutKey: 'Shift+KeyP', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.TOGGLE_TRACKING, shortcutKey: 'KeyS', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.OPACITY, shortcutKey: 'KeyO', type: OS_TYPE.WIN },
  { action: ACTION_TYPE.LABELING.EXCLUSION_AREA, shortcutKey: 'Shift+KeyI', type: OS_TYPE.WIN },
]

export const mergeDefaultShortcuts = (shortcuts: UserShortcut[] = []) => {
  const defaultShortcutMap = new Map(DEFAULT_SHORTCUTS.map((shortcut) => [`${shortcut.type}:${shortcut.action}`, shortcut]))
  const normalizedShortcuts = shortcuts.map((shortcut) => {
    if (shortcut.shortcutKey) {
      return shortcut
    }

    const defaultShortcut = defaultShortcutMap.get(`${shortcut.type}:${shortcut.action}`)

    return defaultShortcut ? { ...shortcut, shortcutKey: defaultShortcut.shortcutKey } : shortcut
  })
  const shortcutIds = new Set(normalizedShortcuts.map(({ action, type }) => `${type}:${action}`))
  const missingDefaults = DEFAULT_SHORTCUTS.filter(({ action, type }) => !shortcutIds.has(`${type}:${action}`))

  return [...normalizedShortcuts, ...missingDefaults]
}

const commonHotKeys = isMac ? COMMON_SHORTCUTS.MAC : COMMON_SHORTCUTS.WIN
const fileHotKeys = isMac ? FILE_SHORTCUTS.MAC : FILE_SHORTCUTS.WIN
const labelHotKeys = isMac ? LABEL_SHORTCUTS.MAC : LABEL_SHORTCUTS.WIN

const HOT_KEYS = {
  ...commonHotKeys,
  ...fileHotKeys,
  ...labelHotKeys,
}

export default HOT_KEYS
